import { useState } from 'react';
import { makeRandomKey } from '../util/makeRandomKey';

export const useRandomKey = (prefix?: string, length?: number) => useState(
  () => makeRandomKey(prefix, length),
)[0];
